// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '../../../../store/rootOrganization';
import useContractStore from '@/app/store/modules/contract';
import actionsContracts from '../../api/actionsContracts';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsContractFromProvider, columnsContractFromProviderId } from './columnDef/columnsContractFromProvider';

/**
 * @param root0
 * @param root0.filtersEventName
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @returns {JSX} ContractsFromProviderTable
 */
function ContractsFromProviderTable({ rowsSelected = undefined, setRowsSelected = undefined, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchContracts: refetchFromStore, storeRefetchContracts, query: queryStored, storeQuery } = useContractStore();

    // Constants
    const initialQuery = getInitialQuery();
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsContracts.getContractsFromProvider(query, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchContracts(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsContractFromProvider({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, selectionMode, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsContractFromProviderId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}
        />
    );
}

ContractsFromProviderTable.propTypes = {
    rowsSelected: PropTypes.object,
    setRowsSelected: PropTypes.func,
    filtersEventName: PropTypes.string
};

export default ContractsFromProviderTable;